export default {
  install(Vue) {
    const eventHub = new Vue();
    Vue.prototype.$eventHub = eventHub;
  },
};
